module.exports = __webpack_public_path__ + "static/img/iphone7-top.8ea4794a.png";